import { render, staticRenderFns } from "./PlayerText.vue?vue&type=template&id=79f97db9&scoped=true&"
import script from "./PlayerText.vue?vue&type=script&lang=js&"
export * from "./PlayerText.vue?vue&type=script&lang=js&"
import style0 from "./PlayerText.vue?vue&type=style&index=0&id=79f97db9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f97db9",
  null
  
)

export default component.exports